module.exports = __webpack_public_path__ + "static/logo-text-blue-0eacad75f91080d98e210276655c5e01.png";